import React from 'react';
import { Row, Col } from 'reactstrap';
import usePatient from '~/utils/patient/hook';
import { UncontrolledTable } from '~/components';
import { format } from 'date-fns';
import { TableFilterDateRange, TableFilterIdentitySource } from '~/components/Filters';
import NoteCell from '~/components/Patient/Identity/NoteCell';
import { MatchStatus } from '~/utils/const/identity';

const Hospitalizations = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <UncontrolledTable
      name="hospitalizations"
      className="mx-4"
      endpoint={{
      url: 'data/public/list-view-cs-tbl-hospitalizations',
      params: {
        sacwisId,
        match_status_id: MatchStatus.Approved,
        'hospadmsntimeTs__<<': format(new Date(), 'MM/DD/YYYY'),
      },
    }}
      defaultSorted={[{ id: 'hospadmsntimeTs__>>', desc: true }]}
      columns={[{
      id: 'hospadmsntimeTs__>>',
      Header: 'Admission Date',
      accessor: 'attributes.hospadmsntimeTs',
      cellType: 'date',
      Filter: d => <TableFilterDateRange {...d} />,
    }, {
      id: 'dischtimeTs',
      Header: 'Discharge Date',
      accessor: 'attributes.dischtimeTs',
      cellType: 'date',
    }, {
      id: 'admitservice',
      Header: 'Admitting Service',
      accessor: 'attributes.admitservice',
    }, {
      id: 'primarydx',
      Header: 'Primary Diagnosis',
      accessor: 'attributes.primarydx',
    }, {
      id: 'sourceDescription',
      Header: 'Reporting Healthcare Insitution',
      accessor: 'attributes.sourceDescription',
      Filter: d => <TableFilterIdentitySource {...d} />,
    }, {
      id: 'hasNotes',
      Header: 'Notes',
      accessor: 'attributes.hasNotes',
      filterable: false,
      Cell: n => <NoteCell {...n} params={{ 'notetype__!': 'Abuse Note' }} />,
    },
  ]}
      SubComponent={({ original: row }) => (
        <div className="p-3">
          <Row>
            <Col sm={2}>
              <h6 className="text-primary">Location</h6>
              {row.attributes.location}
            </Col>

            <Col sm={2}>
              <h6 className="text-primary">Length In Days</h6>
              {Math.ceil(row.attributes.lengthofstay)}
            </Col>

            <Col sm>
              <h6 className="text-primary">Additional Diagnosis</h6>
              {row.attributes.additionaldx}
            </Col>
          </Row>
        </div>
    )}
    />
  );
};

export default Hospitalizations;
